import { Tag } from 'antd'
import { useState } from 'react'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { ToolGroup, toolRunLabel, toolRunStatus } from './messageBubbleModel'
import { toolTagStyle } from './toolCallStyles'
import ToolCallGroup, { ToolStatusIcon } from './ToolCallGroup'

type Props = {
  groups: ToolGroup[]
  expandable?: boolean
  isHistorical?: boolean
  compactToolCalls?: boolean
}

const ToolCallRun = ({ groups, expandable, isHistorical, compactToolCalls }: Props) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div style={{ margin: '4px 0' }}>
      <Tag
        onClick={() => setExpanded(!expanded)}
        style={{
          ...toolTagStyle(!!compactToolCalls),
          cursor: 'pointer',
        }}
      >
        {expanded
          ? <DownOutlined style={{ fontSize: 10 }} />
          : <RightOutlined style={{ fontSize: 10 }} />}
        <ToolStatusIcon status={toolRunStatus(groups, !!isHistorical)} />
        {toolRunLabel(groups, !!isHistorical, !!compactToolCalls)}
      </Tag>
      {expanded && (
        <div style={{ marginLeft: 16 }}>
          {groups.map((group) => (
            <ToolCallGroup
              key={group.callPart.tool_call_id}
              callPart={group.callPart}
              resultPart={group.resultPart}
              expandable={expandable}
              isHistorical={isHistorical}
              compactToolCalls={compactToolCalls}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ToolCallRun
